<!--
  Kommerzielle Landingpage „Blumenautomat kaufen“. Muster wie die übrigen
  Cluster-Seiten. Spielerei: aufblühende Blume (Blütenblätter öffnen sich,
  orange Blütenmitte). Reine CSS/SVG, reduced-motion-sicher.
-->
<section class="bma-hero">
  <div class="content content--wide bma-hero__grid">
    <div class="bma-hero__text reveal">
      <div class="bma-flower" aria-hidden="true">
        <svg viewBox="0 0 100 100" role="img">
          <g class="bma-flower__petals">
            <ellipse cx="50" cy="34" rx="7.5" ry="14" />
            <ellipse cx="50" cy="34" rx="7.5" ry="14" transform="rotate(60 50 52)" />
            <ellipse cx="50" cy="34" rx="7.5" ry="14" transform="rotate(120 50 52)" />
            <ellipse cx="50" cy="34" rx="7.5" ry="14" transform="rotate(180 50 52)" />
            <ellipse cx="50" cy="34" rx="7.5" ry="14" transform="rotate(240 50 52)" />
            <ellipse cx="50" cy="34" rx="7.5" ry="14" transform="rotate(300 50 52)" />
          </g>
          <circle class="bma-flower__center" cx="50" cy="52" r="8.5" />
        </svg>
      </div>
      <span class="bma-eyebrow" i18n="@@bma.hero.eyebrow">Direktvermarktung · 24/7</span>
      <h1 class="title display" i18n="@@bma.hero.h1">Blumenautomat kaufen</h1>
      <div class="line"></div>
      <p class="bma-lead" i18n="@@bma.hero.lead">
        Verkaufe Sträuße, Topfpflanzen und Trockenblumen rund um die Uhr – ohne Ladenöffnungszeiten
        und Personal vor Ort. Die <span class="tm">marktbox</span> ist dein Blumenautomat für Gärtnerei
        und Floristik: bargeldlos, app-gesteuert und wetterfest.
      </p>
      <div class="bma-cta">
        <a class="btn btn-primary bma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bma.hero.ctaShop">Modelle &amp; Preise im Shop</a>
        <a class="bma-cta__ghost" href="#preise" (click)="scrollTo($event, 'preise')" i18n="@@bma.hero.ctaGhost">Kaufen oder mieten? ↓</a>
      </div>
    </div>
    <figure class="bma-hero__media reveal">
      <img src="assets/headers/marktbox-01-1440.webp"
        alt="marktbox Blumenautomat für Gärtnerei und Floristik" i18n-alt="@@bma.hero.imgAlt"
        width="1440" height="960" fetchpriority="high" />
      <span class="bma-hero__badge" i18n="@@bma.hero.badge">🌸 rund um die Uhr</span>
    </figure>
  </div>
</section>

<!-- ===== Vorteile ===== -->
<section class="bma-section">
  <div class="content content--wide">
    <h2 class="bma-h2 reveal" i18n="@@bma.adv.h2">Warum die marktbox als Blumenautomat?</h2>
    <div class="bma-grid">
      <div class="bma-card reveal">
        <span class="bma-card__ico">🕒</span>
        <h3 i18n="@@bma.adv.c1.h">24/7 verkaufen</h3>
        <p i18n="@@bma.adv.c1.p">Blumen für den spontanen Anlass – auch abends, sonntags und feiertags, wenn der Laden zu ist.</p>
      </div>
      <div class="bma-card reveal">
        <span class="bma-card__ico">💳</span>
        <h3 i18n="@@bma.adv.c2.h">Bargeldlos &amp; app-gesteuert</h3>
        <p i18n="@@bma.adv.c2.p">Kartenzahlung am Automaten, Fernwartung und Füllstände per App – ohne täglichen Aufwand vor Ort.</p>
      </div>
      <div class="bma-card reveal">
        <span class="bma-card__ico">💐</span>
        <h3 i18n="@@bma.adv.c3.h">Sträuße &amp; Topfpflanzen</h3>
        <p i18n="@@bma.adv.c3.p">Von der Handbindung bis zur Topfpflanze – flexible Fächer für unterschiedliche Größen.</p>
      </div>
      <div class="bma-card reveal">
        <span class="bma-card__ico">🚜</span>
        <h3 i18n="@@bma.adv.c4.h">Direkt von der Gärtnerei</h3>
        <p i18n="@@bma.adv.c4.p">Verkaufe ohne Zwischenhandel – mit voller Kontrolle über Preis, Auswahl und Präsentation.</p>
      </div>
    </div>
  </div>
</section>

<!-- ===== Live-Link ===== -->
<section class="bma-section bma-live">
  <div class="content content--wide bma-live__grid">
    <div class="bma-live__text reveal">
      <span class="bma-eyebrow" i18n="@@bma.live.eyebrow">Live-Link · Echtzeit</span>
      <h2 class="bma-h2" i18n="@@bma.live.h2">So sieht der Live-Link aus</h2>
      <p class="bma-lead" i18n="@@bma.live.lead">
        Jede marktbox hat ihren eigenen Live-Link: Deine Kundschaft sieht in Echtzeit, was gerade
        verfügbar ist – noch bevor sie losfährt. Das schafft Vertrauen, spart unnötige Wege und bringt
        mehr Verkäufe.
      </p>
      <ul class="bma-live__list">
        <li i18n="@@bma.live.li1">Echtzeit-Verfügbarkeit, rund um die Uhr</li>
        <li i18n="@@bma.live.li2">Teilbar per Link, QR-Code &amp; auf der eigenen Website</li>
        <li i18n="@@bma.live.li3">Ohne App – einfach im Browser</li>
      </ul>
      <div class="bma-cta">
        <a class="btn btn-primary bma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bma.live.cta">Automat mit Live-Link sichern</a>
      </div>
    </div>
    <div class="lp-phonecol reveal">
      <div class="lp-phone">
        <div class="lp-phone__island" aria-hidden="true"></div>
        <div class="lp-phone__screen">
          <iframe [src]="liveUrl"
            title="marktbox Live-Link: Echtzeit-Verfügbarkeit einer Box" i18n-title="@@bma.live.iframeTitle"
            loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
          <div class="lp-phone__hint" aria-hidden="true"><span class="lp-phone__chev"></span> <ng-container i18n="@@lp.phone.scroll">scrollen</ng-container></div>
          <div class="lp-phone__home" aria-hidden="true"></div>
        </div>
        <div class="lp-phone__corners" aria-hidden="true"></div>
      </div>
      <p class="lp-phone__cap"><span class="lp-live__dot"></span> <ng-container i18n="@@bma.live.cap">Live-Beispiel: Gartencenter Pflieger</ng-container></p>
    </div>
  </div>
</section>

<!-- ===== Preise ===== -->
<section id="preise" class="bma-section bma-section--muted">
  <div class="content content--wide">
    <h2 class="bma-h2 reveal" i18n="@@bma.price.h2">Blumenautomat kaufen oder mieten</h2>
    <div class="bma-price-grid">
      <div class="bma-price reveal">
        <span class="bma-price__label" i18n="@@bma.price.buyLabel">Kaufen</span>
        <span class="bma-price__value" i18n="@@bma.price.buyValue">ab {{ priceBuyFrom | number : '1.0-0' }} €</span>
        <p i18n="@@bma.price.buyP">Einmalige Investition, dauerhaft dein Automat – ideal für den langfristigen Betrieb.</p>
      </div>
      <div class="bma-price reveal">
        <span class="bma-price__label" i18n="@@bma.price.rentLabel">Mieten</span>
        <span class="bma-price__value" i18n="@@bma.price.rentValue">ab {{ priceRentFrom }} € / Monat</span>
        <p i18n="@@bma.price.rentP">Niedrige Einstiegshürde, planbare monatliche Kosten – ideal zum Starten und Testen.</p>
      </div>
    </div>
    <div class="bma-cta bma-cta--center reveal">
      <a class="btn btn-primary bma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bma.price.cta">Zum Shop – Blumenautomat konfigurieren</a>
    </div>
    <p class="bma-fineprint reveal" i18n="@@bma.price.fineprint">
      Noch unsicher?
      <a [routerLink]="['/', links.blog, blogSlug]">Im Ratgeber: Wege der Direktvermarktung</a>
    </p>
  </div>
</section>

<!-- ===== Modelle ===== -->
<section class="bma-section">
  <div class="content content--wide">
    <h2 class="bma-h2 reveal" i18n="@@bma.models.h2">Passende Modelle</h2>
    <div class="bma-models">
      <a class="bma-model reveal" [routerLink]="['/', links.shop, 'marktbox-39']">
        <figure class="bma-model__media">
          <img src="assets/rendered/39/webp/frame-0035.webp" alt="marktbox 39 – Blumenautomat mit 39 Fächern" i18n-alt="@@bma.models.m39.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="bma-model__body">
          <h3>marktbox 39</h3>
          <p i18n="@@bma.models.m39.p">39 Fächer – für ein breites Sortiment an Sträußen und Pflanzen.</p>
          <span class="bma-model__more" i18n="@@bma.models.more">Modell ansehen →</span>
        </div>
      </a>
      <a class="bma-model reveal" [routerLink]="['/', links.shop, 'marktbox-24']">
        <figure class="bma-model__media">
          <img src="assets/rendered/24/webp/frame-0035.webp" alt="marktbox 24 – kompakter Blumenautomat mit 24 Fächern" i18n-alt="@@bma.models.m24.alt"
            width="800" height="800" loading="lazy" />
        </figure>
        <div class="bma-model__body">
          <h3>marktbox 24</h3>
          <p i18n="@@bma.models.m24.p">24 Fächer – kompakter Einstieg für Gärtnerei und Hofverkauf.</p>
          <span class="bma-model__more" i18n="@@bma.models.more2">Modell ansehen →</span>
        </div>
      </a>
    </div>
  </div>
</section>

<!-- ===== FAQ ===== -->
<section class="bma-section bma-section--muted">
  <div class="content content--wide">
    <h2 class="bma-h2 reveal" i18n="@@bma.faq.h2">Häufige Fragen zum Blumenautomat</h2>
    <div class="bma-faq reveal">
      @for (f of faqs; track f.q) {
      <details class="bma-faq__item">
        <summary>{{ f.q }}</summary>
        <p>{{ f.a }}</p>
      </details>
      }
    </div>
    <p class="bma-fineprint reveal" i18n="@@bma.faq.fineprint">
      Mehr Praxiswissen im Ratgeber:
      <a [routerLink]="['/', links.blog, blogSlug]">Wege der landwirtschaftlichen Direktvermarktung</a>.
    </p>
  </div>
</section>

<!-- ===== Abschluss-CTA ===== -->
<section class="bma-section bma-final reveal">
  <div class="content content--wide">
    <h2 class="bma-h2" i18n="@@bma.final.h2">Bereit für deinen Blumenautomaten?</h2>
    <p class="bma-lead" i18n="@@bma.final.lead">Finde dein Modell, wähle kaufen oder mieten und starte in die Direktvermarktung.</p>
    <div class="bma-cta bma-cta--center">
      <a class="btn btn-primary bma-cta__pulse" [routerLink]="['/', links.shop]" i18n="@@bma.final.cta">Jetzt Modelle &amp; Preise ansehen</a>
    </div>
  </div>
</section>
